import DisplayManager from './managers/DisplayManager';

(() => {
  if (!window.AVADA_FAQ) return;
  new DisplayManager().initialize();
})();
